"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solace = void 0;
exports.solace = {
    rewards: '0x501ACee6350BB566EBE4A0dABDC9901100B8c445',
    xSolace: '0x501Ace47c5b0C2099C4464f681c3fa2ECD3146C1',
};
